import React from 'react';
import styled from 'styled-components';
import { useLocale } from '@react-aria/i18n';
import { useCalendarGrid } from '@react-aria/calendar';
import { getWeeksInMonth } from '@internationalized/date';
import { CalendarCell } from './CalendarCell';

const CalendarGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    margin-bottom: 8px;
`;

const GridHeader = styled.div`
    font-weight: bold;
    color: gray;
    padding-right: 6px;
`;

const GridCell = styled.div<{ isEmpty?: boolean }>`
`;

export function CalendarGrid({ state, offset = {} }) {
    let { locale } = useLocale();
    let startDate = state.visibleRange.start.add(offset);
    let { gridProps, headerProps, weekDays } = useCalendarGrid(
        {
            weekdayStyle: 'short',
        },
        state,
    );

    // Get the number of weeks in the month so we can render the proper number of rows.
    let weeksInMonth = getWeeksInMonth(startDate, locale);

    return (
        <div {...gridProps}>
            {/* Header Row */}
            <CalendarGridContainer {...headerProps}>
                {weekDays.map((day, index) => (
                    <GridHeader key={index}>{day}</GridHeader>
                ))}
            </CalendarGridContainer>

            {/* Calendar Rows */}
            {[...new Array(weeksInMonth).keys()].map((weekIndex) => (
                <CalendarGridContainer key={weekIndex}>
                    {state
                        .getDatesInWeek(weekIndex, startDate)
                        .map((date, i) =>
                            date ? (
                                <GridCell key={i}>
                                    <CalendarCell
                                        state={state}
                                        date={date}
                                        currentMonth={startDate}
                                    />
                                </GridCell>
                            ) : (
                                <GridCell key={i} isEmpty />
                            ),
                        )}
                </CalendarGridContainer>
            ))}
        </div>
    );
}
